// Calender icon
export const getCalendarSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
  >
    <rect
      x="1"
      y="2.5"
      width="9"
      height="7.5"
      rx="1"
      fill="white"
      stroke="#05073C"
      strokeWidth="0.5"
    />
    <path
      d="M1 4.5C1 3.55719 1 3.08579 1.29289 2.79289C1.58579 2.5 2.05719 2.5 3 2.5H8C8.94281 2.5 9.41421 2.5 9.70711 2.79289C10 3.08579 10 3.55719 10 4.5H1Z"
      fill="#222222"
    />
    <path d="M3 1L3 2.5" stroke="#05073C" strokeLinecap="round" />
    <path d="M8 1L8 2.5" stroke="#05073C" strokeLinecap="round" />
    <rect x="3" y="5.5" width="2" height="1" rx="0.5" fill="#222222" />
    <rect x="3" y="7.5" width="2" height="1" rx="0.5" fill="#222222" />
    <rect x="6" y="5.5" width="2" height="1" rx="0.5" fill="#222222" />
    <rect x="6" y="7.5" width="2" height="1" rx="0.5" fill="#222222" />
  </svg>
);
